import { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { useFlags } from '@lyrahealth-inc/shared-app-logic/src/features/flags/useFlags'

import { LOCAL_STORAGE_KEY } from '../constants/appConstants'

export const useGoogleCatalystBanner = () => {
  const { isGooglePerformanceEnabled } = useFlags()
  const location = useLocation()

  const hasVisitedGooglePerformanceMicrosite =
    localStorage.getItem(LOCAL_STORAGE_KEY.HAS_VISITED_GOOGLE_PERFORMANCE_MICROSITE) === 'true'
  const hasNavigatedToProviderBooking =
    localStorage.getItem(LOCAL_STORAGE_KEY.HAS_NAVIGATED_TO_GOOGLE_PERFORMANCE_PROVIDER_BOOKING) === 'true'
  const [isGoogleCatalystBannerDismissed, setIsGoogleCatalystBannerDismissed] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY.HAS_DISMISSED_GOOGLE_PERFORMANCE_BANNER) === 'true',
  )

  const isOnHomebasePage = location.pathname === '/secure/index/search-care'
  const showGoogleCatalystBanner =
    isGooglePerformanceEnabled &&
    isOnHomebasePage &&
    hasVisitedGooglePerformanceMicrosite &&
    !hasNavigatedToProviderBooking &&
    !isGoogleCatalystBannerDismissed

  return { showGoogleCatalystBanner, setIsGoogleCatalystBannerDismissed }
}
